<div class="page__content">
    <div class="content__inner">
        <div class="content__login">
            <div class="card__login">
                <form *ngIf="!isSuccessful" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
                    <h1>{{ 'FORGOT_PASSWORD.TITLE' | translate }}</h1>

                    <div class="form-group">
                        <input type="email" class="form-control" name="email" [(ngModel)]="form.email" required email #email="ngModel" [placeholder]="'PLACEHOLDER.EMAIL' | translate" />
                        <div class="alert-danger" *ngIf="email.errors && f.submitted">
                            <div *ngIf="email.errors['required']">{{ 'FORGOT_PASSWORD.ERROR.REQUIRED' | translate }}</div>
                            <div *ngIf="email.errors['email']">{{ 'FORGOT_PASSWORD.ERROR.INVALID_EMAIL' | translate }}</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary btn-block" [disabled]="loading">{{ 'FORGOT_PASSWORD.SUBMIT' | translate }}</button>
                    </div>
                    <div class="form-group">
                        <a routerLink="../login" class="forgot-password">{{ 'NOTIFICATION.BUTTON.CANCEL' | translate }}</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
